import { Component } from '@theme/component';

class RentalOrder extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    this.config = JSON.parse(this.querySelector('[data-rental-config]').textContent);
    this.form = this.querySelector('form');
    this.start = this.querySelector('[data-rental-start]');
    this.period = this.querySelector('[data-rental-variant]');
    this.quantity = this.querySelector('[data-rental-quantity]');
    this.generator = this.querySelector('[data-rental-generator]');
    this.delivery = this.querySelector('[data-rental-delivery]');
    this.address = this.querySelector('[data-rental-address]');
    this.error = this.querySelector('[data-rental-error]');
    this.button = this.querySelector('button[type="submit"]');
    const now = new Date();
    this.start.min = [now.getFullYear(),String(now.getMonth()+1).padStart(2,'0'),String(now.getDate()).padStart(2,'0')].join('-');
    this.querySelector('[data-rental-addons]').disabled = false;
    this.querySelector('[data-rental-total-wrap]').hidden = false;
    this.form.addEventListener('change',()=>this.updateTotal(),{signal:this.controller.signal});
    this.form.addEventListener('input',()=>this.updateTotal(),{signal:this.controller.signal});
    this.form.addEventListener('submit',event=>this.addRental(event),{signal:this.controller.signal});
    this.updateTotal();
  }
  disconnectedCallback() {
    this.controller?.abort();
    super.disconnectedCallback();
  }
  money(amount) {
    return new Intl.NumberFormat(this.config.locale,{style:'currency',currency:this.config.currency}).format(amount/100);
  }
  selection() {
    const variant = this.config.variants.find(v=>String(v.id)===this.period.value);
    const generator = this.config.generatorVariants.find(v=>v.title===variant?.title);
    return {variant,generator,quantity:Number(this.quantity.value)};
  }
  updateTotal() {
    const {variant,generator,quantity}=this.selection();
    const weekly=variant?.title==='7-day week';
    this.querySelector('[data-rental-quantity-label]').textContent=weekly?this.config.weeks:this.config.days;
    if(this.generator) {
      this.generator.disabled=!generator?.available;
      if(this.generator.disabled)this.generator.checked=false;
      this.querySelector('[data-rental-generator-price]').textContent=generator?this.money(generator.price):'';
    }
    const deliver=!!this.delivery?.checked;
    this.querySelector('[data-rental-address-wrap]').hidden=!deliver;
    this.address.disabled=!deliver;
    this.address.required=deliver;
    const total=((variant?.price||0)+(this.generator?.checked?generator.price:0))*(Number.isInteger(quantity)&&quantity>0?quantity:0)+(deliver?this.config.deliveryPrice:0);
    this.querySelector('[data-rental-total]').textContent=this.money(total);
  }
  async addRental(event) {
    event.preventDefault();
    if(this.busy||!this.form.reportValidity())return;
    const {variant,generator,quantity}=this.selection();
    if(!variant?.available||!Number.isInteger(quantity)||quantity<1||quantity>365)return;
    this.busy=true;
    this.error.hidden=true;
    this.button.disabled=true;
    this.button.textContent=this.config.adding;
    try {
      const cartResponse=await fetch(this.config.root+'cart.js',{headers:{Accept:'application/json'},signal:this.controller.signal});
      if(!cartResponse.ok)throw new Error(this.config.error);
      const cart=await cartResponse.json();
      const existingDelivery=cart.items.filter(i=>String(i.variant_id)===String(this.config.deliveryId));
      const address=this.address.value.trim();
      if(this.delivery?.checked&&(!address||existingDelivery.some(i=>i.properties?.['Delivery address']!==address||i.properties?.['Requested delivery date']!==this.start.value))) {
        throw new Error(this.config.deliveryConflict);
      }
      const units=variant.title==='7-day week'?7:1;
      const end=new Date(this.start.value+'T12:00:00');
      end.setDate(end.getDate()+quantity*units);
      const endDate=[end.getFullYear(),String(end.getMonth()+1).padStart(2,'0'),String(end.getDate()).padStart(2,'0')].join('-');
      const properties={'Requested start':this.start.value,'Requested return':endDate,'Rental duration':String(quantity*units)+' days','Availability':'Subject to confirmation'};
      const items=[{id:variant.id,quantity,properties}];
      if(this.generator?.checked)items.push({id:generator.id,quantity,properties:{...properties}});
      if(this.delivery?.checked&&!existingDelivery.length)items.push({id:this.config.deliveryId,quantity:1,properties:{'Delivery address':address,'Requested delivery date':this.start.value}});
      const response=await fetch(this.config.root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items}),signal:this.controller.signal});
      const result=await response.json();
      if(!response.ok)throw new Error(result.description||this.config.error);
      window.location.assign(this.config.cartUrl);
    } catch(error) {
      if(error.name==='AbortError')return;
      this.error.textContent=error.message||this.config.error;
      this.error.hidden=false;
      this.error.scrollIntoView({block:'nearest'});
      this.button.disabled=false;
      this.button.textContent=this.config.add;
      this.busy=false;
    }
  }
}
if(!customElements.get('cc-rental-order'))customElements.define('cc-rental-order',RentalOrder);
